module.exports = __webpack_public_path__ + "static/media/my.6540a609.svg";